import React, { useState, useContext } from 'react';
import ProfileCard from './ProfileCard';
import Terminal from './Terminal';
import { ThemeContext } from './ThemeProvider';
import './PortfolioShell.css';

const PortfolioShell = () => {
  const [profileExpanded, setProfileExpanded] = useState(false);
  const { currentTheme } = useContext(ThemeContext);

  return (
    <div className={`portfolio-shell theme-${currentTheme}`}>
      <div className="shell-background">
        <div className="theme-overlay" />
        <div className="animated-bg">
          {currentTheme === 'matrix' && <div className="matrix-rain-bg" />}
          {currentTheme === 'galaxy' && <div className="starfield" />}
          {currentTheme === 'cyberpunk' && <div className="neon-grid" />}
          {currentTheme === 'hacker' && <div className="glitch-overlay" />}
        </div>
      </div>

      <div className="shell-container">
        <div className={`profile-panel ${profileExpanded ? 'expanded' : ''}`}>
          <ProfileCard 
            isExpanded={profileExpanded}
            onToggle={() => setProfileExpanded(!profileExpanded)}
          />
        </div>

        <div className="terminal-panel">
          <Terminal />
        </div>
      </div>

      {/* Mobile gesture handlers */}
      <div className="mobile-gestures">
        <div 
          className="swipe-left-area"
          onTouchStart={(e) => {
            const touch = e.touches[0];
            if (touch.clientX < 50) {
              setProfileExpanded(!profileExpanded);
            }
          }}
        />
      </div>
    </div>
  );
};

export default PortfolioShell;